export default "__VITE_ASSET__PXXF0i16__"